export default "__VITE_ASSET__C6z9cRXf__"